import gsap from 'gsap';
import drawSVGPlugin from '../../plugins/gsap/DrawSVGPlugin';

gsap.registerPlugin(drawSVGPlugin);

export default class HoverSVGAnimation {
    constructor(el) {
        this.el = el;
        this.svg = el.querySelector('[data-svg-hover-animation]');
        if(!this.svg) return;
        this.animationType = this.svg.dataset.svgHoverAnimation;

        if(this.animationType === '') return;

        this.init();
    }

    initTimeline() {
        this.timeline = gsap.timeline({
            paused: true,
            repeat: -1,
        });

        if(this[`animation_${this.animationType}`]) {
            this[`animation_${this.animationType}`]();
        }
    }

    init() {
        this.initTimeline();
        this.el.addEventListener('mouseenter', () => {
            this.timeline.timeScale(1);
            this.runAnimation();
        });

        this.el.addEventListener('mouseleave', () => {
            this.continueAnimationAndPause();
        });
    }

    animation_office_sf() {
        this.totalDuration = 6;
        this.timeline
            .to(this.svg.querySelector('#office-sf-clouds'), {
                duration: this.totalDuration,
                x: "-=278px",
                ease: 'none',
                onComplete: () => {
                    this.timeline.seek(0);
                }
            })

        const lights = document.querySelectorAll("#office-sf-lights path");
        const timeForLight = this.totalDuration / (lights.length + 1);
        lights.forEach((light, index) => {
            this.timeline.to(light, {
                duration: timeForLight * 2,
                opacity: 0,
                delay: timeForLight * index,
                ease: 'none',
            }, 0)

            this.timeline.to(light, {
                duration: timeForLight * 2,
                opacity: 1,
                delay: timeForLight * (index + 3),
                ease: 'none',
            }, 0)
        });
    }

    animation_office_ny() {
        this.totalDuration = 6;

        this.timeline
            .to(this.svg.querySelector('#office-ny-clouds'), {
                duration: this.totalDuration,
                x: "-=164px",
                ease: 'none',
                onComplete: () => {
                    this.timeline.seek(0);
                }
            })

        const windowsLights1 = this.svg.querySelectorAll('#office-ny-windows-1 path');
        const windowsLights2 = this.svg.querySelectorAll('#office-ny-windows-2 path');
        const windowsLights3 = this.svg.querySelectorAll('#office-ny-windows-3 path');

        const timeForLight1 = (this.totalDuration - 1) / (windowsLights1.length + 1);
        windowsLights1.forEach((light, index) => {
            this.timeline.to(light, {
                duration: timeForLight1 * 2,
                opacity: 0,
                ease: 'none',
            }, timeForLight1 * index)

            this.timeline.to(light, {
                duration: timeForLight1 * 2,
                opacity: 1,
                ease: 'none',
            }, timeForLight1 * (index + 3))
        });

        const timeForLight2 = (this.totalDuration - 1) / (windowsLights2.length + 1);
        windowsLights2.forEach((light, index) => {
            this.timeline.to(light, {
                duration: timeForLight2 * 2,
                opacity: 0,
                ease: 'none',
            }, timeForLight2 * index)

            this.timeline.to(light, {
                duration: timeForLight2 * 2,
                opacity: 1,
                ease: 'none',
            }, timeForLight2 * (index + 3))
        });

        const timeForLight3 = (this.totalDuration - 1) / (windowsLights3.length + 1);
        windowsLights3.forEach((light, index) => {
            this.timeline.to(light, {
                duration: timeForLight3 * 2,
                opacity: 0,
                ease: 'none',
            }, timeForLight3 * index)

            this.timeline.to(light, {
                duration: timeForLight3 * 2,
                opacity: 1,
                ease: 'none',
            }, timeForLight3 * (index + 3))
        });
    }

    animation_office_la() {
        this.totalDuration = 6;
        const rays = this.svg.querySelectorAll('#office-la-sunrays path');
        const bird = this.svg.querySelectorAll('#office-la-birds');
        const palm1 = this.svg.querySelectorAll('#office-la-palm-1');
        const palm2 = this.svg.querySelectorAll('#office-la-palm-2');
        const palm3 = this.svg.querySelectorAll('#office-la-palm-3');

        gsap.set(palm1, { transformOrigin: '50% 98%' });
        gsap.set(palm2, { transformOrigin: '50% 98%' });
        gsap.set(palm3, { transformOrigin: '50% 98%' });

        const rayTime = this.totalDuration / 3;
        const phaseTime = rayTime / rays.length;

        const originalPosition = {
             x: 0, //8.5,
             y: 0, //74.6
        }

        const totalPalmsTime = rayTime * 2 + phaseTime * rays.length;
        const palmTime = totalPalmsTime / 4;
        const palm1Rotation = -5;
        const palm2Rotation = 4;
        const palm3Rotation = 3;

        this.timeline
            .to(palm1, {
                duration: palmTime,
                rotate: palm1Rotation,
                ease: 'none',
            }, 0)
            .to(palm1, {
                duration: palmTime * 2,
                rotate: -palm1Rotation,
                ease: 'none',
            }, palmTime)
            .to(palm1, {
                duration: palmTime,
                rotate: 0,
                ease: 'none',
            }, palmTime * 3)

            .to(palm2, {
                duration: palmTime,
                rotate: palm2Rotation,
                ease: 'none',
            }, 0)
            .to(palm2, {
                duration: palmTime * 2,
                rotate: -palm2Rotation,
                ease: 'none',
            }, palmTime)
            .to(palm2, {
                duration: palmTime,
                rotate: 0,
                ease: 'none',
            }, palmTime * 3)

            .to(palm3, {
                duration: palmTime,
                rotate: palm3Rotation,
                ease: 'none',
            }, 0)
            .to(palm3, {
                duration: palmTime * 2,
                rotate: -palm3Rotation,
                ease: 'none',
            }, palmTime)
            .to(palm3, {
                duration: palmTime,
                rotate: 0,
                ease: 'none',
            }, palmTime * 3)

        this.timeline
            .to(bird, {
                duration: rayTime * 2 + phaseTime * rays.length,
                ease: 'none',
                onUpdate: () => {
                    const position = this.timeline.progress() * Math.PI * 2;
                    const dx = Math.cos(position) * 5 - 5 + originalPosition.x;
                    const dy = Math.sin(position) * 5 + originalPosition.y;
                    gsap.set(bird, {
                        x: `${dx}`,
                        y: `${dy}`,
                    })
                }
            }, 0);

        rays.forEach((ray, i) => {
            this.timeline.to(ray, {
                duration: rayTime,
                repeat: 1,
                yoyo: true,
                drawSVG: "0%",
                ease: "none"
            }, i * phaseTime);
        });

        const windowsLights = this.svg.querySelectorAll('#office-la-windows path');
        //randomize the order of lights
        // const lightsOrder = Array.from(windowsLights).sort(() => Math.random() - 0.5);
        const timeForLight = (this.totalDuration - 0.6) / (windowsLights.length + 1);

        windowsLights.forEach((light, index) => {
            this.timeline.to(light, {
                duration: timeForLight * 2,
                opacity: 0,
                ease: 'none',
            }, timeForLight * index)

            this.timeline.to(light, {
                duration: timeForLight * 2,
                opacity: 1,
                ease: 'none',
            }, timeForLight * (index + 3))
        });
    }

    animation_office_la_out() {
        this.totalDuration = 6;
        const rays = this.svg.querySelectorAll('#office-la-sunrays path');

        const rayTime = this.totalDuration / 2;

        this.timeline.pause();

        this.timelineOut = gsap.timeline({
            onComplete: () => {
                this.timeline.seek(0);
            }
        });


        const palm1 = this.svg.querySelectorAll('#office-la-palm-1');
        const palm2 = this.svg.querySelectorAll('#office-la-palm-2');
        const palm3 = this.svg.querySelectorAll('#office-la-palm-3');

        this.timelineOut
            .to(palm1, {
                duration: rayTime,
                rotate: 0,
                ease: 'none',
            }, 0)
            .to(palm2, {
                duration: rayTime,
                rotate: 0,
                ease: 'none',
            }, 0)
            .to(palm3, {
                duration: rayTime,
                rotate: 0,
                ease: 'none',
            }, 0);



        this.timelineOut.to(this.svg.querySelector('#office-la-birds'), {
            duration: rayTime,
            x: 0,
            y: 0,
            ease: 'none',
        }, 0);

        rays.forEach((ray, i) => {
            this.timelineOut.to(ray, {
                duration: rayTime,
                drawSVG: "100%",
                ease: "none"
            }, 0);
        });

        const windowsLights = this.svg.querySelectorAll('#office-la-windows path');
        this.timelineOut.to(windowsLights, {
            duration: 1,
            opacity: 1,
            ease: 'none',
        }, 0);
    }

    animation_office_dc() {
        this.totalDuration = 8;
        this.timeline
            .from("#office-dc-f_btm1",{
                drawSVG: "100% 100%",
                duration: 1.5
            })
            .to("#office-dc-f_btm1",{
                opacity: 0,
                duration: 1
            })
            .fromTo("#office-dc-f_top1",{
                scale:0,
                transformOrigin: "center"
            },{
                scale: 1.3,
                duration: 2
            },"explo")
            .to("#office-dc-f_top1",{
                opacity: 0,
                y:5,
                duration: 2
            })

            .from("#office-dc-f_btm2",{
                drawSVG: "100% 100%",
                duration: 1.5
            }, 1.5)
            .to("#office-dc-f_btm2",{
                opacity: 0,
                duration: 1
            }, 3)
            .fromTo("#office-dc-f_top2",{
                scale:0,
                transformOrigin: "center"
            },{
                scale: 1.3,
                duration: 2
            },4)
            .to("#office-dc-f_top2",{
                opacity: 0,
                y:5,
                duration: 2
            }, 6)

            .to(this.svg.querySelector('#office-dc-clouds'), {
                duration: this.totalDuration,
                x: "-=163px",
                ease: 'none',
                onComplete: () => {
                    this.timeline.seek(0);
                }
            },0)
    }

    animation_office_tokyo() {
        this.totalDuration = 6;

        const bird1 = this.svg.querySelector('#office-tokyo-bird');

        this.timeline
            .to(this.svg.querySelector('#office-tokyo-clouds'), {
                duration: this.totalDuration,
                x: "-=180px",
                ease: 'none',
                onComplete: () => {
                    this.timeline.seek(0);
                }
            })

        this.timeline
            .to(bird1, {
                duration: this.totalDuration,
                ease: 'none',
                onUpdate: () => {
                    const position = this.timeline.progress() * Math.PI * 2;
                    const dx = Math.cos(position) * 5 - 5;
                    const dy = Math.sin(position) * 5;
                    gsap.set(bird1, {
                        x: `${dx}`,
                        y: `${dy}`,
                    })
                }
            }, 0);
    }

    animation_office_uk() {
        this.totalDuration = 6;
        this.timeline
            .to(this.svg.querySelector('#office-uk-clouds'), {
                duration: this.totalDuration,
                x: "-=180px",
                ease: 'none',
                onComplete: () => {
                    this.timeline.seek(0);
                }
            })

        const bird1 = this.svg.querySelector('#office-uk-bird1');
        const bird2 = this.svg.querySelector('#office-uk-bird2');

        const clockRay1 = this.svg.querySelector('#office-uk-clock-ray1');
        const clockRay2 = this.svg.querySelector('#office-uk-clock-ray2');

        this.timeline
            .to(bird1, {
                duration: this.totalDuration,
                ease: 'none',
                onUpdate: () => {
                    const position = this.timeline.progress() * Math.PI * 2;
                    const dx = Math.cos(position) * 3 - 3;
                    const dy = Math.sin(position) * 3;
                    gsap.set(bird1, {
                        x: `${dx}`,
                        y: `${dy}`,
                    })
                }
            }, 0);

        this.timeline
            .to(bird2, {
                duration: this.totalDuration,
                ease: 'none',
                onUpdate: () => {
                    const position = this.timeline.progress() * Math.PI * 2;
                    const dx = Math.sin(position) * 5;
                    const dy = Math.cos(position) * 5 - 5;
                    gsap.set(bird2, {
                        x: `${dx}`,
                        y: `${dy}`,
                    })
                }
            }, 0);

        this.timeline
            .to(clockRay1, {
                duration: this.totalDuration,
                ease: 'none',
                rotate: 1440,
                transformOrigin: "0 12",
            }, 0);

        this.timeline
            .to(clockRay2, {
                duration: this.totalDuration,
                ease: 'none',
                rotate: 360,
                transformOrigin: "1 0",
            }, 0);
    }

    animation_office_mp () {
        this.totalDuration = 6;
        this.timeline
            .to(this.svg.querySelector('#office-mp-clouds'), {
                duration: this.totalDuration,
                x: "-=191px",
                ease: 'none',
                onComplete: () => {
                    this.timeline.seek(0);
                }
            })

        const signals = document.querySelectorAll("#office-mp-signals path");

        const signalRepeats = 2;
        const timeForSignal = (this.totalDuration - 0.1) / signalRepeats / (signals.length);

        for (let i = 0; i < signalRepeats; i++) {
            this.timeline.to(signals, {
                duration: 0.1,
                opacity: 0,
                ease: 'none',
            }, 0.1 + timeForSignal * signals.length * i);

            signals.forEach((signal, index) => {
                this.timeline.to(signal, {
                    duration: timeForSignal,
                    opacity: 1,
                    ease: 'none',
                }, 0.2 + timeForSignal * index + timeForSignal * signals.length * i);
            });
        }

        const lights = document.querySelectorAll("#office-mp-windows path");
        const timeForLight = (this.totalDuration - 0.6) / (lights.length + 1);
        lights.forEach((light, index) => {
            this.timeline.to(light, {
                duration: timeForLight * 2,
                opacity: 0,
                ease: 'none',
            }, timeForLight * index)

            this.timeline.to(light, {
                duration: timeForLight * 2,
                opacity: 1,
                ease: 'none',
            }, timeForLight * (index + 3))
        });
    }

    animation_office_la2() {
        this.totalDuration = 6;
        const rays = this.svg.querySelectorAll('#office-la2-sunrays path');
        const bird = this.svg.querySelectorAll('#office-la2-birds');
        const palm1 = this.svg.querySelectorAll('#office-la2-palm-1');
        const palm2 = this.svg.querySelectorAll('#office-la2-palm-2');
        const palm3 = this.svg.querySelectorAll('#office-la2-palm-3');
        const circleRight = this.svg.querySelector('#office-la2-circle-right');
        const circleLeft = this.svg.querySelector('#office-la2-circle-left');

        gsap.set(palm1, { transformOrigin: '50% 98%' });
        gsap.set(palm2, { transformOrigin: '50% 98%' });
        gsap.set(palm3, { transformOrigin: '50% 98%' });

        const rayTime = this.totalDuration / 3;
        const phaseTime = rayTime / rays.length;

        const originalPosition = {
            x: 0, //8.5,
            y: 0, //74.6
        }

        const totalPalmsTime = rayTime * 2 + phaseTime * rays.length;
        const palm1Rotation = -5;
        const palm2Rotation = 4;
        const palm3Rotation = 3;

        gsap.set(palm1, { y: "+=110%" });
        gsap.set(palm2, { y: "+=110%" });
        gsap.set(palm3, { y: "+=110%" });

        gsap.set(palm1, { opacity: 1 });
        gsap.set(palm2, { opacity: 1 });
        gsap.set(palm3, { opacity: 1 });

        this.timelineIntro = gsap.timeline({
            repeat: 0,
            paused: true,
        })
            .to(circleRight, {
                duration: .5,
                drawSVG: "100% 20%",
                ease: 'power2.out',
            }, 0)
            .to(circleLeft, {
                duration: .5,
                drawSVG: "67%",
                ease: 'power2.out',
            }, 0)
        .to([palm1, palm2, palm3],
            {
                duration: .5,
                y: 0,
                ease: 'power2.out',
                stagger: .1,
            }, 0)

        this.timeline
            .to(palm1, {
                duration: totalPalmsTime / 4,
                rotate: palm1Rotation,
                ease: 'none',
            }, 0)
            .addLabel('palmRight')
            .to(palm1, {
                duration: totalPalmsTime / 2,
                rotate: -palm1Rotation,
                ease: 'none',
            }, 'palmRight')
            .addLabel('palmLeft')
            .to(palm1, {
                duration: totalPalmsTime / 4,
                rotate: 0,
                ease: 'none',
            }, 'palmLeft')

            .to(palm2, {
                duration: totalPalmsTime / 4,
                rotate: palm2Rotation,
                ease: 'none',
            }, 0)
            .to(palm2, {
                duration: totalPalmsTime / 2,
                rotate: -palm2Rotation,
                ease: 'none',
            }, 'palmRight')
            .to(palm2, {
                duration: totalPalmsTime / 4,
                rotate: 0,
                ease: 'none',
            }, 'palmLeft')

            .to(palm3, {
                duration: totalPalmsTime / 4,
                rotate: palm3Rotation,
                ease: 'none',
            }, 0)
            .to(palm3, {
                duration: totalPalmsTime / 2,
                rotate: -palm3Rotation,
                ease: 'none',
            }, 'palmRight')
            .to(palm3, {
                duration: totalPalmsTime / 4,
                rotate: 0,
                ease: 'none',
            }, 'palmLeft')

        this.timeline
            .to(bird, {
                duration: rayTime * 2 + phaseTime * rays.length,
                ease: 'none',
                onUpdate: () => {
                    const position = this.timeline.progress() * Math.PI * 2;
                    const dx = Math.cos(position) * 5 - 5 + originalPosition.x;
                    const dy = Math.sin(position) * 5 + originalPosition.y;
                    gsap.set(bird, {
                        x: `${dx}`,
                        y: `${dy}`,
                    })
                }
            }, 0);

        rays.forEach((ray, i) => {
            this.timeline.to(ray, {
                duration: rayTime,
                repeat: 1,
                yoyo: true,
                drawSVG: "0%",
                ease: "none"
            }, i * phaseTime);
        });

        const windowsLights = this.svg.querySelectorAll('#office-la2-windows path');
        //randomize the order of lights
        // const lightsOrder = Array.from(windowsLights).sort(() => Math.random() - 0.5);
        const timeForLight = (this.totalDuration - 0.6) / (windowsLights.length + 1);

        windowsLights.forEach((light, index) => {
            this.timeline.to(light, {
                duration: timeForLight * 2,
                opacity: 0,
                ease: 'none',
            }, timeForLight * index)

            this.timeline.to(light, {
                duration: timeForLight * 2,
                opacity: 1,
                ease: 'none',
            }, timeForLight * (index + 3))
        });
    }

    animation_office_la2_out() {
        this.totalDuration = 6;
        const rays = this.svg.querySelectorAll('#office-la2-sunrays path');

        const rayTime = this.totalDuration / 2;

        this.timeline.pause();

        this.timelineOut = gsap.timeline({
            onComplete: () => {
                this.timeline.seek(0);
            }
        });

        if(this.timelineIntro) {
            this.timelineIntro.reverse();
        }

        const palm1 = this.svg.querySelectorAll('#office-la2-palm-1');
        const palm2 = this.svg.querySelectorAll('#office-la2-palm-2');
        const palm3 = this.svg.querySelectorAll('#office-la2-palm-3');

        this.timelineOut
            .to(palm1, {
                duration: rayTime,
                rotate: 0,
                ease: 'none',
            }, 0)
            .to(palm2, {
                duration: rayTime,
                rotate: 0,
                ease: 'none',
            }, 0)
            .to(palm3, {
                duration: rayTime,
                rotate: 0,
                ease: 'none',
            }, 0);



        this.timelineOut.to(this.svg.querySelector('#office-la2-birds'), {
            duration: rayTime,
            x: 0,
            y: 0,
            ease: 'none',
        }, 0);

        rays.forEach((ray, i) => {
            this.timelineOut.to(ray, {
                duration: rayTime,
                drawSVG: "100%",
                ease: "none"
            }, 0);
        });

        const windowsLights = this.svg.querySelectorAll('#office-la2-windows path');
        this.timelineOut.to(windowsLights, {
            duration: 1,
            opacity: 1,
            ease: 'none',
        }, 0);
    }

    runAnimation() {
        this.timeline.play();
        if(this.timelineIntro) {
            this.timelineIntro.play();
        }
    }

    continueAnimationAndPause() {
        if(this[`animation_${this.animationType}_out`]) {
            this[`animation_${this.animationType}_out`]();
        } else {
            const totalDuration = this.totalDuration;
            const remainingTime = (totalDuration - this.timeline.time()) / 2;
            this.timeline.timeScale(2);

            gsap.delayedCall(remainingTime, () => {
                this.timeline.pause();
            });
        }
    }
}
